/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/
// /lang/locales/km-KH.js

const kmMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 រក្សាសិទ្ធិគ្រប់យ៉ាង។',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'ការចូលគណនី',
  'user.register': 'ចុះឈ្មោះ',
  'user.forgot-password': 'ភ្លេចពាក្យសម្ងាត់',
  'user.email': 'អ៊ីមែល',
  'user.newpassword': 'ពាក្យសម្ងាត់ថ្មី',
  'user.currentpassword': 'ពាក្យសម្ងាត់បច្ចុប្បន្ន',
  'user.newpasswordagain': 'បញ្ចូលពាក្យសម្ងាត់ថ្មីម្តងទៀត',
  'user.password': 'ពាក្យសម្ងាត់',
  'user.forgot-password-question': 'ភ្លេចពាក្យសម្ងាត់?',
  'user.fullname': 'ឈ្មោះពេញ',
  'user.firstname': 'នាមខ្លួន',
  'user.lastname': 'នាមត្រកូល',
  'user.login-button': 'ចូល',
  'user.register-button': 'ចុះឈ្មោះ',
  'user.reset-password-button': 'កំណត់ឡើងវិញ',
  'user.buy': 'ទិញ',
  'user.username': 'ឈ្មោះអ្នកប្រើ',

  /* 03.Menu */
  'menu.app': 'ទំព័រដើម',
  'menu.online': 'អនឡាញ',
  'menu.offline': 'អ៊ភឡាញ',
  'menu.default': 'លំនាំដើម',
  'menu.analytics': 'វិភាគ',
  'menu.ecommerce': 'ពាណិជ្ជកម្មអេឡិចត្រូនិក',
  'menu.content': 'មាតិকা',
  'menu.pages': 'ទំព័រ',
  'menu.data-list': 'បញ្ជីទិន្នន័យ',
  'menu.thumb-list': 'បញ្ជីរូបតូច',
  'menu.image-list': 'បញ្ជីរូបភាព',
  'menu.details': 'ព័ត៌មានលម្អិត',
  'menu.search': 'ស្វែងរក',
  'menu.login': 'ចូលគណនី',
  'menu.register': 'ចុះឈ្មោះ',
  'menu.forgot-password': 'ភ្លេចពាក្យសម្ងាត់?',
  'menu.error': 'កំហុស',
  'menu.applications': 'កម្មវិធី',
  'menu.todo': 'បញ្ជីត្រូវធ្វើ',
  'menu.survey': 'ស៊ើវេ',
  'menu.chat': 'ជជែក',
  'menu.ui': 'UI',
  'menu.edit': 'កែសម្រួល',
  'menu.alerts': 'សារ​ប្រាប់ដំណឹង',
  'menu.badges': 'បដិមា',
  'menu.buttons': 'ប៊ូតុង',
  'menu.cards': 'កាត',
  'menu.carousel': 'រ័ត្នតស៊ូល',
  'menu.charts': 'តារាង',
  'menu.collapse': 'រឹតបន្តឹង',
  'menu.dropdowns': 'បញ្ជីជម្រៅចុះ',
  'menu.editors': 'កែសម្រួល',
  'menu.form-layouts': 'រចនាទម្រង់សំណុំបែបបទ',
  'menu.form-components': 'ធាតុខាងក្នុងសំណុំបែបបទ',
  'menu.form-validations': 'ការផ្ទៀងផ្ទាត់សំណុំបែបបទ',
  'menu.icons': 'រូបសញ្ញា',
  'menu.input-groups': 'ក្រុមបញ្ចូលព័ត៌មាន',
  'menu.jumbotron': 'ជាំប៊ឺត្រូន៍',
  'menu.modal': 'ប៊ិចប៊ុក',
  'menu.navigation': 'ការរុករក',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'អាចតម្រៀបបាន',
  'menu.tables': 'តារាង',
  'menu.menu': 'ម៉ឺនុយ',
  'menu.subhidden': 'រងលាក់',
  'menu.hidden': 'លាក់',
  'menu.visible': 'មើលឃើញ',
  'menu.maps': 'ផែនទី',
  'menu.landingpage': 'ទំព័រស្វាគមน์',
  'menu.multipage-home': 'ទំព័រម៉៊ុលទីភេកស្គើម',
  'menu.singlepage-home': 'ទំព័រតែមួយ',
  'menu.about': 'អំពី',
  'menu.auth-login': 'ចូលសម្គាល់សម្គាល់',
  'menu.auth-register': 'ចុះឈ្មោះសម្គាល់',
  'menu.blog': 'ប្លុក',
  'menu.blog-detail': 'ព័ត៌មានលម្អិតប្លុក',
  'menu.careers': 'មុខងារការងារ',
  'menu.confirmation': 'ការបញ្ជាក់',
  'menu.contact': 'ទំនាក់ទំនង',
  'menu.docs': 'ឯកសារ',
  'menu.features': 'លក្ខណៈពិសេស',
  'menu.prices': 'តម្លៃ',
  'menu.videos': 'វីដេអូ',
  'menu.mailing': 'ការផ្ញើសារ​ទៅអ៊ីមែល',
  'menu.invoice': 'វិក័យបត្រ',
  'menu.blank-page': 'ទីនេះឆាប់ៗនេះ...',
  'menu.types': 'ប្រភេទម៉ឺនុយ',
  'menu.levels': 'កម្រិតម៉ឺនុយ',
  'menu.third-level-1': 'កម្រិតទី៣-1',
  'menu.third-level-2': 'កម្រិតទី៣-2',
  'menu.third-level-3': 'កម្រិតទី៣-3',

  /* 04.Dashboards */
  'dashboards.update': 'បន្ទាន់សម័យ',
  'dashboards.save': 'រក្សាទុក',
  'dashboards.name': 'ឈ្មោះ',
  'dashboards.button': 'ប៊ូតុង',
  'dashboards.visits': 'ចុះទស្សនា',
  'dashboards.checkAvailability': 'ពិនិត្យភាពអាចប្រើបាន ឬ អត្រា',
  'dashboards.details': 'ព័ត៌មានលម្អិត',
  'dashboards.pending-orders': 'ការបញ្ជាទិញកំពុងទុកចាំ',
  'dashboards.completed-orders': 'ការបញ្ជាទិញបានបញ្ចប់',
  'dashboards.refund-requests': 'សំណើសុំសងប្រាក់',
  'dashboards.new-comments': 'មតិយោបល់ថ្មីៗ',
  'dashboards.sales': 'ការលក់',
  'dashboards.orders': 'ការបញ្ជាទិញ',
  'dashboards.refunds': 'ការសងប្រាក់',
  'dashboards.recent-orders': 'ការបញ្ជាទិញថ្មីៗ',
  'dashboards.product-categories': 'ប្រភេទផលិតផល',
  'dashboards.cakes': 'នំខេក',
  'dashboards.tickets': 'សំបុត្រ',
  'dashboards.calendar': 'ប្រតិទិន',
  'dashboards.best-sellers': 'ផលិតផលលក់ដាច់',
  'dashboards.per-session': 'ក្នុងមួយសម័យ',
  'dashboards.profile-status': 'ស្ថានភាពប្រវត្តិរូប',
  'dashboards.payment-status': 'ស្ថានភាពការទូទាត់',
  'dashboards.work-progress': 'ដំណើរការងារ',
  'dashboards.tasks-completed': 'ភារកិច្ចបានបញ្ចប់',
  'dashboards.payments-done': 'ការទូទាត់បានសម្រេច',
  'dashboards.order-stock': 'បញ្ជាទិញ - ផ្លូវចេញស្តុក',
  'dashboards.categories': 'ប្រភេទ',
  'dashboards.quick-post': 'បង្ហោះឆាប់',
  'dashboards.title': 'ចំណងជើង',
  'dashboards.content': 'មាតិការសារព័ត៌មាន',
  'dashboards.ticket-count': 'ចំនួនសំបុត្រ',
  'dashboards.commonticketsubmission': 'ការដាក់ស្នើសំបុត្រញឹកញាប់',
  'dashboards.category': 'ប្រភេទ',
  'dashboards.save-and-publish': 'រក្សាទុក និង ផ្សព្វផ្សាយ',
  'dashboards.top-viewed-posts': 'ការបង្ហោះដែលបានមើលច្រើនបំផុត',
  'dashboards.posts': 'ការបង្ហោះ',
  'dashboards.pending-for-publish': 'ចាំសម្រាប់ផ្សព្វផ្សាយ',
  'dashboards.users': 'អ្នកប្រើប្រាស់',
  'dashboards.on-approval-process': 'នៅក្នុងដំណើរការអនុម័ត',
  'dashboards.alerts': 'សារ​ប្រាប់​ដំណឹង',
  'dashboards.waiting-for-notice': 'កំពុងរងចាំសេចក្ដីជូនដំណឹង',
  'dashboards.files': 'ឯកសារ',
  'dashboards.pending-for-print': 'ចាំសម្រាប់បោះពុម្ព',
  'dashboards.logs': 'កំណត់ហេតុ',
  'dashboards.gogo': 'GO GO',
  'dashboards.magic-is-in-the-details': 'អស្ចារ្យស្ថិតនៅក្នុងព័ត៌មានលម្អិត',
  'dashboards.yes-it-is-indeed': 'បាទ, វាជាការពិត!',
  'dashboards.advanced-search': 'ស្វែងរកជាន់ខ្ពស់',
  'dashboards.toppings': 'ថែមទាំង',
  'dashboards.type': 'ប្រភេទ',
  'dashboards.keyword': 'ពាក្យគន្លឹះ',
  'dashboards.search': 'ស្វែងរក',
  'dashboards.top-rated-items': 'ធាតុបានផ្ដល់ពិន្ទុខ្ពស់',
  'dashboards.country': 'ប្រទេស',
  'dashboards.webVisitors': 'អ្នកទស្សនាវេបសាយ',
  'dashboards.avatarClicks': 'ចុចអាវ៉ាតារ',
  'dashboards.wordCloud': 'ពពកពាក្យ',
  'dashboards.topic': 'ប្រធានបទ',
  'dashboards.roomsAvailability': 'បន្ទប់ & ភាពអាចប្រើបាន',
  'dashboards.startChat': 'ចាប់ផ្តើមសន្ទនា',
  'dashboards.restaurantsBars': 'ភោជនីយដ្ឋាន & នៅបារ',
  'dashboards.groupBooking': 'កក់ក្រុម',
  'dashboards.promotions': 'ការផ្សព្វផ្សាយ',
  'dashboards.weedingevents': 'ព្រឹត្តិការណ៍អាពាហ៍ពិពា & ពិធីការ',
  'dashboards.lostsomething': 'បានបាត់អ្វីមួយ',
  'dashboards.producttext': 'អត្ថបទផលិតផល',
  'dashboards.bookingroomnew': 'កក់បន្ទប់ថ្មី',
  'dashboards.email': 'អ៊ីមែល',
  'dashboards.phone': 'ទូរស័ព្ទ',
  'dashboards.zipcode': 'លេខកូតតំបន់',
  'dashboards.marketingconsent': 'ការយល់ព្រមទីផ្សារ',
  'dashboards.additionalinfo': 'ព័ត៌មានបន្ថែម',
  'dashboards.viewallcontacts': 'មើលទាក់ទងទាំងអស់',
  'dashboards.current': 'បច្ចុប្បន្ន',
  'dashboards.last7days': '៧ថ្ងៃចុងក្រោយ',
  'dashboards.last30days': '៣០ថ្ងៃចុងក្រោយ',
  'dashboards.thisweek': 'សប្ដាហ៍នេះ',
  'dashboards.thismonth': 'ខែនេះ',
  'dashboards.previousmonth': 'ខែមុន',
  'dashboards.yeartodate': 'ឆ្នាំដល់បច្ចុប្បន្ន',
  'dashboards.lastyear': 'ឆ្នាំមុន',
  'dashboards.all': 'ទាំងអស់',
  'dashboards.standardOccupancy': 'ភាពនៅស្នាក់ស្តង់ដា',
  'dashboards.max-occupancy': 'ភាពនៅស្នាក់អតិបរិមា',
  'dashboards.numberOfThisType': 'ចំនួននៃប្រភេទនេះ',
  'dashboards.displayOrder': 'លំដាប់បង្ហាញ',
  'dashboards.provider': 'អ្នកផ្គត់ផ្គង់',
  'dashboards.edit': 'កែសម្រួល',
  'dashboards.delete': 'លុប',
  'dashboards.addImages': 'បន្ថែមរូបភាព',
  'dashboards.near': 'នៅជិត',
  'dashboards.calling_party': 'អ្នកហៅ',
  'dashboards.called_party': 'អ្នកដែលត្រូវហៅ',
  'dashboards.lastdial': 'ហៅចុងក្រោយ',
  'dashboards.imagelink': 'តំណររូបភាព',
  'dashboards.browsegallery': 'រុករកបណ្ណាល័យ',
  'dashboards.changelog': 'កំណត់ហេតុការផ្លាស់ប្ដូរ',
  'dashboards.externalresources': 'ធនធានខាងក្រៅ',
  'dashboards.webpage': 'ទំព័របណ្តាញ',
  'dashboards.web-pages': 'ទំព័របណ្តាញៗ',
  'dashboards.published': 'បានផ្សព្វផ្សាយ',
  'dashboards.adddocument': 'បន្ថែមឯកសារ',
  'dashboards.ready-to-publish': 'រួចរាល់សម្រាប់ផ្សព្វផ្សាយ',
  'dashboards.draft': 'សេចក្ដីទាក់ទង',
  'dashboards.order-by': 'បញ្ជាទិញ​ដោយ',
  'dashboards.add-faq': 'បន្ថែមសំណួរញឹកញាប់',
  'dashboards.collections': 'ការរើសរើស',
  /* 04.Dashboards */
  'dashboards.items': 'ធាតុ',
  'dashboards.rooms-availability': 'បន្ទប់ និងភាពអាចរកបាន',
  'dashboards.events-wedding-venues': 'ព្រឹត្តិការណ៍ និងទីតាំងអាពាហ៍ពិពាហ៍',
  'dashboards.long-stay-enquiry': 'សំណួរស្នាក់នៅរយៈពេលវែង',
  'dashboards.reservation-confirmation-request': 'សំណើបញ្ជាក់ការកក់',
  'dashboards.modify-cancel-booking': 'កែប្រែ ឬលុបការកក់',
  'dashboards.left-something-behind': 'បាត់អ្វីមួយនៅពីក្រោយ',
  'dashboards.invoice-copy': 'ច្បាប់ចម្លងវិក្កយបត្រ / បង្កាន់ដៃ',
  'dashboards.sync': 'ធ្វើសមកាលកម្ម',
  'dashboards.add-web-page': 'បន្ថែមទំព័របណ្ដាញ',
  'dashboards.sprint-title': 'ស្គាល់ Sprint — បច្ចេកវិទ្យាដ៏អស្ចារ្យសម្រាប់បណ្តុះបណ្តាលម៉ូដែល AI ក្នុងពេលតិចជាង ១០ ដង។',
  'dashboards.sprint-description': 'Sprint ដំណើរការជាមួយអ្នក ដើម្បីបើកចំហភាពច្នៃប្រឌិត បង្កើនផលិតភាព និងកាត់បន្ថយពេលវេលាដើម្បីបណ្តុះបណ្តាលជំនួយការឌីជីថល។',
  'dashboards.sprint-feature': 'លក្ខណៈពិសេស Sprint ត្រូវបានរចនាឡើងដើម្បីធ្វើសមកាលកម្មចំណេះដឹងពីប្រភពខាងក្រៅ ដែលមានប្រយោជន៍សម្រាប់ការកំណត់ដំបូង និងការធ្វើបច្ចុប្បន្នភាពទិន្នន័យបន្ត។ នៅពេលដំណើរការលើប្រព័ន្ធសកម្ម Sprint នឹងកែប្រែ Knowledge Hub អាស្រ័យលើប្រភពខាងក្រៅដែលអ្នកកំណត់ ដែលអាចប៉ះពាល់ដោយផ្ទាល់ដល់អាកប្បកិរិយា និងចម្លើយដែលបង្កើតដោយ AI។ សម្រាប់ជំនួយក្នុងការកំណត់ Sprint សូមទាក់ទងក្រុមគាំទ្ររបស់យើង។',
  'dashboards.change-password': 'ផ្លាស់ប្តូរពាក្យសម្ងាត់',
  'dashboards.sign-out': 'ចេញពីគណនី',
  'dashboards.privacy-policy': 'គោលការណ៍ឯកជនភាព',
  'dashboards.help-center': 'មជ្ឈមណ្ឌលជំនួយ',
  'dashboards.switch-account': 'ប្ដូរគណនី',
  'dashboards.business-settings': 'ការកំណត់អាជីវកម្ម',
  'dashboards.notifications-allowed': 'អនុញ្ញាតការជូនដំណឹង',
  'dashboards.dark-theme': 'ស្បែកងងឹត',
  'dashboards.online': 'អនឡាញ',
  'dashboards.offline': 'អុហ្វឡាញ',
  'dashboards.invoice-&-payments': 'វិក្កយបត្រ និងការទូទាត់',
  'dashboards.upgrade-plan': 'បង្កើនផែនការ',
  'dashboards.add-room': 'បន្ថែមបន្ទប់',
  'dashboards.room-type': 'ប្រភេទបន្ទប់',
  'dashboards.room-name': 'ឈ្មោះបន្ទប់',
  'dashboards.how-many-guests': 'តើមានភ្ញៀវប៉ុន្មាននាក់អាចស្នាក់នៅក្នុងបន្ទប់នេះ?',
  'dashboards.number-of-rooms-this-type': 'ចំនួនបន្ទប់ (ប្រភេទនេះ)',
  'dashboards.number-of-bedrooms': 'ចំនួនបន្ទប់គេង',
  'dashboards.number-of-livingrooms': 'ចំនួនបន្ទប់ទទួលភ្ញៀវ',
  'dashboards.minimum-adults': 'ចំនួនមនុស្សពេញវ័យអប្បបរមា',
  'dashboards.maximum-adults': 'ចំនួនមនុស្សពេញវ័យអតិបរមា',
  'dashboards.maximum-children': 'ចំនួនកុមារអតិបរមា',
  'dashboards.maximum-infants': 'ចំនួនទារកអតិបរមា',
  'dashboards.extra-beds-allowed': 'អនុញ្ញាតគ្រែបន្ថែម',
  'dashboards.booking-engine-code': 'លេខកូដប្រព័ន្ធកក់បន្ទប់',
  'dashboards.room-size': 'ទំហំបន្ទប់',
  'dashboards.balcony-area': 'ផ្ទៃបាល់ខនី',
  'dashboards.unit': 'ឯកតា',
  'dashboard.whatsapp_message': 'វាយសាររបស់អ្នកនៅទីនេះ...',
  'dashboard.whatsapp_reply_window': 'អ្នកមានពេល 24 ម៉ោង ដើម្បីឆ្លើយតបទៅសាររបស់អតិថិជននៅលើ WhatsApp Business ចាប់ពីពេលអតិថិជនផ្ញើសារចុងក្រោយ។ ប្រសិនបើអ្នកឆ្លើយតបក្នុងអំឡុងពេលសេវាកម្មអតិថិជន 24 ម៉ោងនេះ អ្នកអាចផ្ញើសារប្រភេទណាមួយបាន។ បន្ទាប់ពីអំឡុងពេល 24 ម៉ោងបិទ អ្នកអាចផ្ញើសារបានតែតាមរយៈគំរូសារដែលបានអនុម័តជាមុនប៉ុណ្ណោះ ហើយអំឡុងពេល 24 ម៉ោងនឹងចាប់ផ្តើមឡើងវិញនៅពេលអតិថិជនឆ្លើយតប។',
  'dashboards.square-meters': 'ម៉ែត្រការ៉េ',
  "dashboard.pick_quick_reply": "ជ្រើសរើសការឆ្លើយតបរហ័ស ឬវាយសាររបស់អ្នក",
  "dashboard.hang_in_there": "សូមរង់ចាំ ខណៈពេលយើងកំពុងព្យាយាមភ្ជាប់អ្នក!",
  "dashboard.outbound_msg": "ពេលវេលាផ្ញើសារចេញ",
  "dashboard.message_sent": "សាររបស់អ្នកត្រូវបានផ្ញើដោយជោគជ័យ!",
  "dashboard.failed_msg": "បរាជ័យក្នុងការផ្ញើសារ",
  "dashboard.new_chat_message": "សារជជែកថ្មី",
  "dashboard.user_msg": "មានសារពីអ្នកប្រើប្រាស់ក្នុងរយៈពេល 24 ម៉ោងចុងក្រោយ។ អ្នកអាចឆ្លើយតបដោយសារណាមួយ។ តើអ្នកនៅតែចង់ផ្ញើសារគំរូនេះ ឬឆ្លើយតបដោយសារផ្សេងទៀត?",
  "dashboard.us_number": "សារ WhatsApp Business មិនត្រូវបានផ្ញើទៅលេខសហរដ្ឋអាមេរិកទេ ព្រោះ Meta បានផ្អាកសារផ្សព្វផ្សាយទាំងអស់ទៅលេខសហរដ្ឋអាមេរិកនៅថ្ងៃទី 1 ខែមេសា ឆ្នាំ 2025។",
  "dashboard.error_msg": "សូមបំពេញកន្លែងបំពេញទាំងអស់ឱ្យបានត្រឹមត្រូវ។",


  /* Web Widget */

  'web-widget.title': 'ម៉ឺនុយ Widget សម្រាប់បញ្ចូលជាមួយជំនួយការចាប់ផ្តើមជជែកលើគេហទំព័រ',

  /* Home Page */
  'dashboards.quickstartwithai': 'ចាប់ផ្តើមលឿនជាមួយ AI',
  'dashboards.fastestpathtoautomation': 'អ្នកស្ថិតនៅលើផ្លូវលឿនបំផុតទៅរកការប្រតិបត្តិដោយស្វ័យប្រវត្តិជាមួយឧបករណ៍ AI',
  'dashboards.insightsthatempower': 'ការយល់ដឹងដែលផ្តល់អំណាច',
  'dashboards.trainchatbot': 'បណ្តុះបណ្តាលជំនួយការជជែក (Chatbot)',
  'dashboards.automatewithforms': 'ស្វ័យប្រវត្តិកម្មជាមួយទម្រង់',
  'dashboards.inroomdigitalcompendium': 'សៀវភៅណែនាំឌីជីថលក្នុងបន្ទប់',
  'dashboards.support': 'ការគាំទ្រ',
  'dashboards.helpcenter': 'មជ្ឈមណ្ឌលជំនួយ',
  'dashboards.searchfaqintegrations': 'ស្វែងរកអត្ថបទអំពីសំណួរញឹកញាប់ ការរួមបញ្ចូល និងផ្សេងទៀត។',
  'dashboards.asklivechat': 'សួរពីសំណួរទៅកាន់ក្រុមការងាររបស់យើងតាមការជជែកផ្ទាល់',
  'dashboards.inroomqrcode': 'កូដ QR ក្នុងបន្ទប់សម្រាប់មើលព័ត៌មានអំពីអចលនទ្រព្យ និងទីតាំង',
  'dashboards.customizewebwidget': 'ប្តូរតាមចំណូលចិត្ត និងបន្ថែម Widget ទៅលើគេហទំព័ររបស់អ្នកជាមួយ Chatbot ដែលមាន AI រួមបញ្ចូល',
  'dashboards.createcustomforms': 'បង្កើតទម្រង់ផ្ទាល់ខ្លួន និងទទួលបានការជូនដំណឹងនៅពេលភ្ញៀវដាក់ស្នើទម្រង់',
  'dashboards.trainchatbotproperty': 'បណ្តុះបណ្តាល Chatbot ជាមួយព័ត៌មានអំពីអចលនទ្រព្យដូចជា ពេលវេលាចូលស្នាក់ កម្មវិធីសកម្មភាព និងច្រើនទៀត។',
  'dashboards.chatbotinsights': 'មើលពីរបៀបដែល Chatbot របស់អ្នកទាក់ទងជាមួយភ្ញៀវ និងទទួលបានការវិភាគស្ថិតិដូចជា អ្នកទស្សនាវេបសាយ សំណួរញឹកញាប់ និងច្រើនទៀត។',
  'dashboards.addaichatbottoyourwebsite': 'បន្ថែម Chatbot AI ទៅលើគេហទំព័ររបស់អ្នក',

  /* Email Stats */
  'dashboards.thread-summary-title': 'សង្ខេបខ្សែអ៊ីមែល',
  'dashboards.thread-summary-subtitle': 'សង្ខេបអ៊ីមែលដែលបង្កើតដោយ AI',
  'dashboards.ai-replies-title': 'ចម្លើយ AI',
  'dashboards.ai-replies-subtitle': 'ចម្លើយដែលបង្កើតដោយ AI',
  'dashboards.total-thread-summary-title': 'ចំនួនសង្ខេបអ៊ីមែលសរុបដែលបានបង្កើត',
  'dashboards.total-ai-replies-title': 'ចំនួនចម្លើយ AI សរុបដែលបានបង្កើត',
  'dashboards.total-draft-copied': 'សេចក្ដីព្រាងដែលអ្នកប្រើបានចម្លង',
  'dashboards.urgency': 'ភាពបន្ទាន់',
  'dashboards.sentiment': 'អារម្មណ៍',
  'dashboards.common-email-reasons': 'មូលហេតុអ៊ីមែលទូទៅ',
  'dashboards.topics-in-emails': 'ប្រធានបទក្នុងអ៊ីមែល',
  'dashboards.email-assistant-usage': 'ការប្រើប្រាស់ជំនួយការអ៊ីមែល AI',
  'dashboards.usage-by-email-address': 'ការប្រើប្រាស់តាមអាសយដ្ឋានអ៊ីមែល',
  /* 05.Pages */
  'pages.title.dashboards.analytics': 'វិភាគ',
  'pages.title.ari': 'ភាពអាចរកបាន និងតម្លៃ',
  'pages.title.conversations': 'សន្ទនា',
  'pages.title.bookings': 'ការកក់ និងការបញ្ជាទិញ',
  'pages.title.tickets': 'ការទំនាក់ទំនង និងសំបុត្រ',
  'pages.title.propinfo': 'ការឆ្លើយតប',
  'pages.title.discounts': 'ការបញ្ចុះតម្លៃ និងការផ្សព្វផ្សាយ',
  'pages.title.finance': 'ហិរញ្ញវត្ថុ',
  'pages.title.integration': 'ការរួមបញ្ចូល',
  'pages.title.admin': 'អ្នកគ្រប់គ្រង',
  'pages.add-new': 'បន្ថែមថ្មី',
  'pages.add-new-modal-title': 'បន្ថែមធាតុថ្មី',
  'pages.display-options': 'ជម្រើសបង្ហាញ',
  'pages.orderby': 'តម្រៀបតាម៖ ',
  'pages.product-name': 'ឈ្មោះផលិតផល',
  'pages.category': 'ប្រភេទ',
  'pages.description': 'ការពិពណ៌នា',
  'pages.status': 'ស្ថានភាព',
  'pages.cancel': 'បោះបង់',
  'pages.submit': 'ដាក់ស្នើ',
  'pages.delete': 'លុប',
  'pages.another-action': 'សកម្មភាពផ្សេងទៀត',
  'pages.actions': 'សកម្មភាព',
  'pages.header': 'ក្បាលទំព័រ',
  'pages.details': 'ព័ត៌មានលម្អិត',
  'pages.orders': 'ការបញ្ជាទិញ',
  'pages.rating': 'ការវាយតម្លៃ',
  'pages.price': 'តម្លៃ',
  'pages.ingredients': 'គ្រឿងផ្សំ',
  'pages.is-vegan': 'ជាមនុស្សបួស',
  'pages.order-status': 'ស្ថានភាពការបញ្ជាទិញ',
  'pages.bake-progress': 'ដំណើរការអ៊ុត',
  'pages.popularity': 'ប្រជាប្រិយភាព',
  'pages.comments': 'មតិយោបល់',
  'pages.error-title': 'អូ... មានកំហុសមួយកើតឡើង!',
  'pages.error-code': 'លេខកំហុស',
  'pages.go-back-home': 'ត្រឡប់ទៅទំព័រដើម',
  'pages.mailing-info': 'គំរូអ៊ីមែលប្រើស្ទីល inline និងប្លង់តារាង ដើម្បីបង្ហាញបានល្អនៅតាមសេវាកម្មផ្សេងៗ។ សម្រាប់ភាពងាយស្រួល យើងបញ្ចូលវាជា HTML ធម្មតា។',
  'pages.invoice-info': 'គំរូវិក្កយបត្រមានស្ទីល inline សម្រាប់ប្រើក្រៅគម្រោង និងកំណែ React ផងដែរ។',
  'pages.react-version': 'កំណែ React',
  'pages.inline-version': 'កំណែ HTML មានស្ទីល Inline',

  /* 06.Applications */
  /* 06.01.Chat */
  'chat.messages': 'សារទាំងអស់',
  'chat.contacts': 'ទំនាក់ទំនង',
  'chat.saysomething': 'និយាយអ្វីមួយ...',

  /* 06.02.Survey */
  'survey.delete': 'លុប',
  'survey.edit': 'កែសម្រួល',
  'survey.add-new': 'បន្ថែមថ្មី',
  'survey.add-new-title': 'បន្ថែមការស្ទង់មតិថ្មី',
  'survey.title': 'ចំណងជើង',
  'survey.category': 'ប្រភេទ',
  'survey.label': 'ស្លាក',
  'survey.status': 'ស្ថានភាព',
  'survey.cancel': 'បោះបង់',
  'survey.submit': 'ដាក់ស្នើ',
  'survey.another-action': 'សកម្មភាពផ្សេងទៀត',
  'survey.display-options': 'ជម្រើសបង្ហាញ',
  'survey.orderby': 'តម្រៀបតាម៖ ',
  'survey.all-surveys': 'ការស្ទង់មតិទាំងអស់',
  'survey.completed-surveys': 'បានបញ្ចប់',
  'survey.categories': 'ប្រភេទ',
  'survey.active-surveys': 'ស្ទង់មតិកំពុងដំណើរការ',
  'survey.labels': 'ស្លាក',

  /* 06.03.Todo */
  'todo.add-new': 'បន្ថែមថ្មី',
  'todo.add-new-title': 'បន្ថែមការងារថ្មី',
  'todo.title': 'ចំណងជើង',
  'todo.detail': 'ព័ត៌មានលម្អិត',
  'todo.category': 'ប្រភេទ',
  'todo.label': 'ស្លាក',
  'todo.status': 'ស្ថានភាព',
  'todo.cancel': 'បោះបង់',
  'todo.submit': 'ដាក់ស្នើ',
  'todo.action': 'សកម្មភាព',
  'todo.another-action': 'សកម្មភាពផ្សេងទៀត',
  'todo.display-options': 'ជម្រើសបង្ហាញ',
  'todo.orderby': 'តម្រៀបតាម៖ ',
  'todo.all-tasks': 'ភារកិច្ចទាំងអស់',
  'todo.pending-tasks': 'ភារកិច្ចកំពុងរង់ចាំ',
  'todo.completed-tasks': 'បានបញ្ចប់',
  'todo.categories': 'ប្រភេទ',
  'todo.labels': 'ស្លាក',

  /* 07.UI */
  /* 07.01.Alerts */
  'alert.rounded': 'ការជូនដំណឹងមូល',
  'alert.react-notifications': 'ការជូនដំណឹង React',
  'alert.outline': 'ស៊ុមក្រៅ',
  'alert.primary': 'សំខាន់',
  'alert.secondary': 'រង',
  'alert.info': 'ព័ត៌មាន',
  'alert.success': 'ជោគជ័យ',
  'alert.warning': 'ព្រមាន',
  'alert.error': 'កំហុស',
  'alert.filled': 'បំពេញ',
  'alert.primary-text': 'នេះជាការជូនដំណឹងសំខាន់—សូមពិនិត្យមើល!',
  'alert.secondary-text': 'នេះជាការជូនដំណឹងរង—សូមពិនិត្យមើល!',
  'alert.success-text': 'ជោគជ័យ! សូមពិនិត្យមើល!',
  'alert.danger-text': 'មានបញ្ហា! សូមពិនិត្យ!',
  'alert.warning-text': 'ការព្រមាន! សូមយកចិត្តទុកដាក់!',
  'alert.info-text': 'ព័ត៌មានសំខាន់!',
  'alert.light-text': 'ការជូនដំណឹងពន្លឺ',
  'alert.dark-text': 'ការជូនដំណឹងងងឹត',
  'alert.default': 'ការជូនដំណឹងលំនាំដើម',
  'alert.dismissing': 'ការជូនដំណឹងអាចបិទបាន',
  'alert.dismissing-text': 'សូមពិនិត្យព័ត៌មានខាងក្រោមម្តងទៀត។',
  'alert.dismissing-without-animate-text': 'ការជូនដំណឹងនេះអាចបិទដោយគ្មានចលនា!',

  /* 07.02.Badges */
  'badge.sizes': 'ទំហំ',
  'badge.colors': 'ពណ៌',
  'badge.outline': 'ស៊ុមក្រៅ',
  'badge.links': 'តំណភ្ជាប់',
  'badge.counter-badges': 'សញ្ញាចំនួន',
  'badge.bootstrap-default': 'លំនាំដើម Bootstrap',
  'badge.primary': 'សំខាន់',
  'badge.secondary': 'រង',
  'badge.success': 'ជោគជ័យ',
  'badge.danger': 'គ្រោះថ្នាក់',
  'badge.warning': 'ព្រមាន',
  'badge.info': 'ព័ត៌មាន',
  'badge.light': 'ពន្លឺ',
  'badge.dark': 'ងងឹត',

  /* 07.03.Buttons */
  'button.default': 'លំនាំដើម Bootstrap',
  'button.colors': 'ពណ៌',
  'button.rounded': 'មូល',
  'button.outline': 'ស៊ុមក្រៅ',
  'button.states': 'ស្ថានភាព',
  'button.sizes': 'ទំហំ',
  'button.button-groups': 'ក្រុមប៊ូតុង',
  'button.large-button': 'ប៊ូតុងធំ',
  'button.small-button': 'ប៊ូតុងតូច',
  'button.extra-small-button': 'ប៊ូតុងតូចបន្ថែម',
  'button.block-button': 'ប៊ូតុងពេញប្លុក',
  'button.active': 'សកម្ម',
  'button.disabled': 'បិទដំណើរការ',
  'button.basic': 'មូលដ្ឋាន',
  'button.toolbar': 'របារឧបករណ៍',
  'button.nesting': 'ប៊ូតុងជាប់គ្នា',
  'button.vertical-variation': 'បែបបញ្ឈរ',
  'button.checkbox-radio-button': 'ប្រអប់ធីក និងប៊ូតុងវិទ្យុ',
  'button.checkbox': 'ប្រអប់ធីក',
  'button.radio': 'ប៊ូតុងវិទ្យុ',
  'button.radio-button': 'ប៊ូតុងវិទ្យុ',
  'button.primary': 'សំខាន់',
  'button.secondary': 'រង',
  'button.success': 'ជោគជ័យ',
  'button.danger': 'គ្រោះថ្នាក់',
  'button.warning': 'ព្រមាន',
  'button.info': 'ព័ត៌មាន',
  'button.light': 'ពន្លឺ',
  'button.dark': 'ងងឹត',
  'button.states-text': 'ប៊ូតុងនេះបង្ហាញ spinner ២ វិនាទី និងសញ្ញាកំហុស ៣ វិនាទី មុនត្រឡប់ទៅស្ថានភាពធម្មតា។',
  'button.click-here': 'ចុចទីនេះ',
  'button.states-text-alternate': 'ប៊ូតុងនេះបង្ហាញសញ្ញាផ្លាស់ប្តូរស្ថានភាពជាបណ្តោះអាសន្ន។',
  'button.primary-link': 'តំណសំខាន់',
  'button.link': 'តំណភ្ជាប់',
  'button.primary-button': 'ប៊ូតុងសំខាន់',
  'button.button': 'ប៊ូតុង',
  'button.left': 'ឆ្វេង',
  'button.middle': 'កណ្ដាល',
  'button.right': 'ស្ដាំ',
  'button.dropdown': 'បញ្ជីទម្លាក់ចុះ',
  'button.dropdown-link': 'តំណបញ្ជីទម្លាក់ចុះ',

  /* 07.04.Cards */
  'cards.icon-card': 'កាតរូបតំណាង',
  'cards.image-card': 'កាតរូបភាព',
  'cards.image-overlay-card': 'កាតរូបភាពមានស្រទាប់',
  'cards.image-card-list': 'បញ្ជីកាតរូបភាព',
  'cards.tab-card': 'កាតផ្ទាំង',
  'cards.user-card': 'កាតអ្នកប្រើ',

  /* 07.05.Carousel */
  'carousel.basic': 'ស្លាយមូលដ្ឋាន',
  'carousel.single': 'ស្លាយតែមួយ',
  'carousel.without-controls': 'ស្លាយគ្មានបញ្ជា',

  /* 07.06.Charts */
  'charts.line': 'ក្រាហ្វបន្ទាត់',
  'charts.polar': 'ក្រាហ្វមូល',
  'charts.area': 'ក្រាហ្វតំបន់',
  'charts.scatter': 'ក្រាហ្វចំណុច',
  'charts.bar': 'ក្រាហ្វដំបង',
  'charts.radar': 'ក្រាហ្វរ៉ាដា',
  'charts.pie': 'ក្រាហ្វនំខេក',
  'charts.doughnut': 'ក្រាហ្វដូណាត់',
  'charts.shadow': 'ស្រមោល',
  'charts.no-shadow': 'គ្មានស្រមោល',

  /* 07.07.Collapse */
  'collapse.basic': 'មូលដ្ឋាន',
  'collapse.toggle': 'បិទ/បើក',
  'collapse.accordion': 'អាករដ្យុង',
  'collapse.controlled': 'គ្រប់គ្រងដោយ',
  'collapse.uncontrolled': 'មិនគ្រប់គ្រង',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'មូលដ្ឋាន',
  'dropdowns.controlled': 'គ្រប់គ្រង',
  'dropdowns.uncontrolled': 'មិនគ្រប់គ្រង',
  'dropdowns.dropdown': 'បញ្ជីទម្លាក់ចុះ',
  'dropdowns.header': 'ក្បាល',
  'dropdowns.action': 'សកម្មភាព',
  'dropdowns.another-action': 'សកម្មភាពផ្សេងទៀត',
  'dropdowns.right': 'ស្ដាំ',
  'dropdowns.left': 'ឆ្វេង',
  'dropdowns.drop-directions': 'ទិសដៅទម្លាក់ចុះ',
  'dropdowns.dropright': 'ទម្លាក់ស្ដាំ',
  'dropdowns.dropleft': 'ទម្លាក់ឆ្វេង',
  'dropdowns.small-button': 'ប៊ូតុងតូច',
  'dropdowns.large-button': 'ប៊ូតុងធំ',
  'dropdowns.sizing': 'ទំហំ',
  'dropdowns.split-button': 'ប៊ូតុងបំបែក',
  'dropdowns.dropup': 'ទម្លាក់ឡើង',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill ស្តង់ដារ',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'មូលដ្ឋាន',
  'forms.email': 'អ៊ីមែល',
  'forms.email-muted': 'យើងនឹងមិនចែករំលែកអ៊ីមែលរបស់អ្នកជាមួយអ្នកណាទេ។',
  'forms.password': 'ពាក្យសម្ងាត់',
  'forms.submit': 'ដាក់ស្នើ',
  'forms.horizontal': 'ផ្តេក',
  'forms.radios': 'ប៊ូតុងវិទ្យុ',
  'forms.first-radio': 'ប៊ូតុងទីមួយ',
  'forms.second-radio': 'ប៊ូតុងទីពីរ',
  'forms.third-radio-disabled': 'ប៊ូតុងទីបី (បិទ)',
  'forms.checkbox': 'ប្រអប់ធីក',
  'forms.signin': 'ចូលគណនី',
  'forms.top-labels-over-line': 'ស្លាកនៅលើបន្ទាត់',
  'forms.tags': 'ស្លាក',
  'forms.date': 'កាលបរិច្ឆេទ',
  'forms.state': 'រដ្ឋ',
  'forms.top-labels-in-input': 'ស្លាកនៅក្នុងប្រអប់',
  'forms.email-u': 'អ៊ីមែល',
  'forms.password-u': 'ពាក្យសម្ងាត់',
  'forms.tags-u': 'ស្លាក',
  'forms.date-u': 'កាលបរិច្ឆេទ',
  'forms.state-u': 'រដ្ឋ',
  'forms.grid': 'បណ្តាញ',
  'forms.address': 'អាសយដ្ឋាន',
  'forms.address2': 'អាសយដ្ឋានទី ២',
  'forms.city': 'ទីក្រុង',
  'forms.city-message': 'សូមជ្រើសទីក្រុង!',
  'forms.state-message': 'សូមជ្រើសរដ្ឋ!',
  'forms.zip': 'លេខប្រៃសណីយ៍',
  'forms.signup': 'ចុះឈ្មោះ',
  'forms.inline': 'បន្ទាត់តែមួយ',
  'forms.validation-availity': 'សុពលភាព Availity Reactstrap',
  'forms.validation-formik': 'សុពលភាព Formik',
  'forms.default': 'លំនាំដើម',
  'forms.firstname': 'នាមខ្លួន',
  'forms.firstname-message': 'សូមបញ្ចូលនាមខ្លួន!',
  'forms.lastname': 'នាមត្រកូល',
  'forms.lastname-message': 'សូមបញ្ចូលនាមត្រកូល!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'ប្រអប់បញ្ចូលផ្ទាល់ខ្លួន',
  'form-components.checkboxes': 'ប្រអប់ធីក',
  'form-components.radios': 'ប៊ូតុងវិទ្យុ',
  'form-components.inline': 'បន្ទាត់តែមួយ',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'រដ្ឋតែមួយ',
  'form-components.state-multiple': 'រដ្ឋច្រើន',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'ជ្រើសកាលបរិច្ឆេទ',
  'form-components.date': 'កាលបរិច្ឆេទ',
  'form-components.date-range': 'ជួរកាលបរិច្ឆេទ',
  'form-components.date-with-time': 'កាលបរិច្ឆេទជាមួយម៉ោង',
  'form-components.embedded': 'បង្កប់',
  'form-components.dropzone': 'តំបន់ទម្លាក់ឯកសារ',
  'form-components.drop-files-here': 'ទម្លាក់ឯកសារនៅទីនេះ',
  'form-components.tags': 'ស្លាក',
  'form-components.switch': 'បិទ/បើក',
  'form-components.primary': 'សំខាន់',
  'form-components.secondary': 'រង',
  'form-components.primary-inverse': 'សំខាន់បញ្ច្រាស',
  'form-components.secondary-inverse': 'រងបញ្ច្រាស',
  'form-components.slider': 'ស្លាយដឺរ',
  'form-components.double-slider': 'ស្លាយពីរ',
  'form-components.single-slider': 'ស្លាយតែមួយ',
  'form-components.rating': 'ការវាយតម្លៃ',
  'form-components.interactive': 'អន្តរកម្ម',
  'form-components.readonly': 'អានតែប៉ុណ្ណោះ',
  'form-components.type-a-cake': 'វាយអត្ថបទ',
  'form-components.start': 'ចាប់ផ្តើម',
  'form-components.end': 'បញ្ចប់',
  'form-components.tables': 'តារាង',

  /* 07.12.Icons */
  'icons.simplelineicons': 'រូបតំណាង Simple Line',
  'icons.iconsmind': 'រូបតំណាង Iconsmind',

  /* 07.13.Input Groups */
  /* 07.13.Input Groups */
  'input‑groups.basic': 'មូលដ្ឋាន',
  'input‑groups.sizing': 'ទំហំ',
  'input‑groups.small': 'តូច',
  'input‑groups.default': 'លំនាំដើម',
  'input‑groups.large': 'ធំ',
  'input‑groups.checkboxes‑and‑radios': 'ប្រអប់ធីក និង ប៊ូតុងវិទ្យុ',
  'input‑groups.multiple‑inputs': 'បញ្ចូលច្រើន',
  'input‑groups.first‑and‑last‑name': 'នាមខ្លួន និង នាមត្រកូល',
  'input‑groups.multiple‑addons': 'កម្មវិធីបន្ថែមច្រើន',
  'input‑groups.button‑addons': 'ប៊ូតុងបន្ថែម',
  'input‑groups.button': 'ប៊ូតុង',
  'input‑groups.buttons‑with‑dropdowns': 'ប៊ូតុងជាមួយបញ្ជីទម្លាក់ចុះ',
  'input‑groups.dropdown': 'បញ្ជីទម្លាក់ចុះ',
  'input‑groups.header': 'ក្បាល',
  'input‑groups.action': 'សកម្មភាព',
  'input‑groups.another‑action': 'សកម្មភាពផ្សេងទៀត',
  'input‑groups.custom‑select': 'ជ្រើសរើសផ្ទាល់ខ្លួន',
  'input‑groups.options': 'ជម្រើស',
  'input‑groups.choose': 'ជ្រើសរើស...',
  'input‑groups.custom‑file‑input': 'បញ្ចូលឯកសារផ្ទាល់ខ្លួន',

  /* 07.14.Jumbotron */
  'jumbotron.hello‑world': 'សួស្តី​លោកលោកស្រី!',
  'jumbotron.lead': 'នេះជាឧបករណ៍ hero ងាយស្រួល ប្រើសម្រាប់ទាក់ទាញការចាប់អារម្មណ៍ទៅមាតិការសំខាន់ៗ។',
  'jumbotron.lead‑detail': 'វាអ្នកប្រើថ្នាក់បម្រើ typography និង spacing ដើម្បីបែងចែកមាតិកាក្នុងក្រោមទំហំធង្ក។',
  'jumbotron.learn‑more': 'សូមស្វែងយល់ច្រើនទៀត',

  /* 07.15.Modal */
  'modal.basic': 'មូលដ្ឋាន',
  'modal.modal‑title': 'ចំណងជើងម៉ូឌុល',
  'modal.launch‑demo‑modal': 'ចាប់ផ្តើមម៉ូឌុលរំលឹក',
  'modal.scrolling‑long‑content': 'មាតិកាក្នុងម៉ូឌុលរហូតច្រើន',
  'modal.backdrop': 'ផ្ទៃខាងក្រោយ',
  'modal.backdrop‑value': 'តម្លៃផ្ទៃខាងក្រោយ',
  'modal.right‑modal': 'ម៉ូឌុលផ្នែកស្ដាំ',
  'modal.launch‑right‑modal': 'ចាប់ផ្តើមម៉ូឌុលផ្នែកស្ដាំ',
  'modal.nested‑modal': 'ម៉ូឌុលរួមបញ្ចូល',
  'modal.size': 'ទំហំ',
  'modal.launch‑large‑modal': 'ចាប់ផ្តើមម៉ូឌុលធំ',
  'modal.launch‑small‑modal': 'ចាប់ផ្តើមម៉ូឌុលតូច',

  /* 07.16.Navigation */
  'nav.basic': 'Nav មូលដ្ឋាន',
  'nav.active': 'សកម្ម',
  'nav.disabled': 'មិនដំណើរការ',
  'nav.disabled‑link': 'តំណភ្ជាប់មិនដំណើរការ',
  'nav.link': 'តំណភ្ជាប់',
  'nav.longer‑link': 'តំណភ្ជាប់វែងជាង',
  'nav.another‑link': 'តំណភ្ជាប់ផ្សេងទៀត',
  'nav.right': 'ស្ដាំ',
  'nav.dropdown': 'បញ្ជីទម្លាក់ចុះ',
  'nav.header': 'ក្បាល',
  'nav.action': 'សកម្មភាព',
  'nav.another‑action': 'សកម្មភាពផ្សេងទៀត',
  'nav.horizontal‑alignment': 'ការតម្រឹមផ្លូវកណ្ដាល',
  'nav.vertical‑alignment': 'ការតម្រឹមបញ្ឈរ',
  'nav.pills': 'ផ្ទាំង Nav',
  'nav.fill‑justify': 'បំពេញ និង សមមាត្រ',
  'nav.pills‑dropdowns': 'ផ្ទាំង Nav ជាមួយបញ្ជីទម្លាក់ចុះ',
  'nav.pagination‑basic': 'ចំណាត់ថ្នាក់មូលដ្ឋាន',
  'nav.pagination‑sizing': 'ទំហំនៃចំណាត់ថ្នាក់',
  'nav.large': 'ធំ',
  'nav.small': 'តូច',
  'nav.center': 'កណ្​មេខាងកណ្តាល',
  'nav.pagination‑alignment': 'ការតម្រឹមចំណាត់ថ្នាក់',
  'nav.breadcrumb‑basic': 'Breadcrumb មូលដ្ឋាន',

  /* 07.17.Popover & Tooltip */
  'popover‑tooltip.popover': 'Popover',
  'popover‑tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'ជួរឈរ​តម្រៀបបាន',
  'sortable.basic': 'មូលដ្ឋាន',
  'sortable.handles': 'ដើមទ្រនិច',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'តារាង Bootstrap',
  'table.bootstrap-basic': 'តារាងមូលដ្ឋាន',
  'table.bootstrap-striped': 'ជួរទទឹកសា (Striped Rows)',
  'table.bootstrap-bordered': 'តារាងមានព្រំដែន',
  'table.bootstrap-borderless': 'តារាងគ្មានព្រំដែន',
  'table.bootstrap-hoverable': 'ជួរដែលអាចបញ្ជើតបាន (Hoverable Rows)',
  'table.bootstrap-responsive': 'តារាងឆាប់មានប្រតិកម្ម (Responsive Table)',
  'table.react-tables': 'តារាង React',
  'table.react-pagination': 'ចំនាត់តារាង (Pagination)',
  'table.react-scrollable': 'អាចរមួលរវើក (Scrollable)',
  'table.react-advanced': 'តម្រង់, ប្រវែង និង លោត (Filter, Length and Jump)',

  /* Property Info */
  'property-info.allcustomers': 'អតិថិជនទាំងអស់',
  'property-info.external-sources': 'ប្រភពខាងក្រៅ',
  'property-info.faq': 'សំណួរញឹកញាប់ (FAQs)',
  'property-info.documents': 'ឯកសារ',
  'property-info.publish-ai': 'ផ្សព្វផ្សាយ AI',
  'property-info.pre-built-templates': 'ទម្រង់ដែលបានសាងស្រាប់',
  'property-info.room-types': 'ប្រភេទបន្ទប់',
  'property-info.about-property': 'អំពីអចលនទ្រព្យ',
  'property-info.about-properties': 'អំពីអចលនទ្រព្យ​(ច្រើន)',
  'property-info.facilities-services': 'សេវាកម្ម និង អគារសេវា',
  'property-info.property-facilities': 'អគារសេវា​អចលនទ្រព្យ',
  'property-info.room-amenities': 'ទំនិញបន្ថែម​បន្ទប់',
  'property-info.property-contact': 'ទំនាក់ទំនងអចលនទ្រព្យ',
  'property-info.property-activities': 'សកម្មភាពអចលនទ្រព្យ',
  'property-info.property-location': 'ទីតាំងអចលនទ្រព្យ',
  'property-info.about-rooms': 'អំពីបន្ទប់',
  'property-info.about-sites': 'អំពីតំបន់',
  'property-info.special-emergencies': 'ករណីបន្ទាន់ពិសេស',
  'property-info.gallery': 'រូបភាពបណ្ណាល័យ',
  'property-info.policies': 'នយោបាយ',
  'property-info.nearby': 'នៅជិត',
  'property-info.transport': 'ការដឹកជញ្ជូន',
  'property-info.location': 'ទីតាំង',
  'property-info.about-rhproperty': 'អំពីផ្ទះជួលសម្រាប់អ្នកចល័ត​ចាស់',
  'property-info.related-topics': 'ប្រធានបទសម្របសម្រួល',
  'property-info.assistant-options': 'សារការស្វាគមន៍',
  'property-info.restaurant-assistant-information': 'ព័ត៌មានភោជនីយដ្ឋាន',
  'property-info.restaurant-assistant-options': 'សារការស្វាគមន៍',
  'property-info.channel-messages': 'សារឆ្នេររ៉ូបប៊ែល',
  'property-info.icon.gallery': 'បណ្ណាល័យរូបសញ្ញា',
  'property-info.copilot': 'ជំនួយការផ្នែកគ្រប់គ្រង',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'ព័ត៌មានផ្ទះ',
  'property-info.loction': 'ទីតាំង',
  'property-info.rooms-and-images': 'បន្ទប់ និង រូបភាព',
  'property-info.trainig-data': 'ទិន្នន័យបណ្ដុះបណ្ដាល AI',
  'property-info.publishMonitor': 'ផ្សព្វផ្សាយ និង ត្រួតពិនិត្យ',
  'property-info.webWidget': 'វិលជ័របណ្តាញ',
  'property-info.media': 'ប្រព័ន្ធព័ត៌មានមូលដ្ឋាន',
  'property-info.flows': 'ហ្វ្លូវ(Flows)',
  'property-info.add-your-own': 'បន្ថែមរបស់អ្នកផ្ទាល់',
  'property-info-utility-miscellaneous': 'ផ្សេងៗ',
  'property-info-utility-payment': 'ការទូទាត់',
  'property-info-utility-broadband': 'បណ្តាញទូលំទូលាយ',
  'property-info-utility-emergency': 'ករណីបន្ទាន់',
  'property-info-utility-mobile': 'ទូរស័ព្ទចល័ត',
  'property-info-utility-moving': 'ចល័ត',

  /** Rate & Promo */
  'rate-promo.rate-plans': 'ផែនការកក់ចុះតំលៃ',
  'rate-promo.rate-plan-addons': 'ការបន្ថែមផែនការ',
  'rate-promo.rate-plan-promos': 'ការផ្សព្វផ្សាយ',

  'title.property-information': 'ព័ត៌មានអចលនទ្រព្យ',

  'property.message': 'សារ',
  'property.example': 'ឧទាហរណ៍',
  'property.link': 'តំណភ្ជាប់',
  'property.image-carousel': 'រមើលរូបភាព',
  'property.Title': 'ចំណងជើង',
  'property.SubTitle': 'ចំណងជើងរង',

  'property.add-invoke-api': 'អំពើ API',
  'property.add-message-button': 'បន្ថែមសារ',
  'property.add-img-button': 'បន្ថែមរូបភាព',
  'property.add-link-button': 'បន្ថែមតំណភ្ជាប់',

  'property.add-herocard-button': 'បន្ថែមការបួនដើម (Hero Card)',
  'property.add-api-button': 'បន្ថែមប៊ូតុង',

  'menu.settings': 'ការកំណត់',
  'menu.workflows': 'ចរន្តការងារ',
  'menu.product_services': 'ផលិតផល និង សេវាកម្ម',
  'menu.product_recommander': 'កម្មវិធីផ្តល់ ផលិតផល អនុសាសនា',
  'menu.digital_guide_book': 'សៀវភៅណែនាំឌីជីថល',
  'menu.welcome_message': 'សារស្វាគមន៍',
  'menu.about-property': 'អំពីអចលនទ្រព្យ',
  'menu.property-facilities': 'អាគារសេវា​អចលនទ្រព្យ',
  'menu.room-amenities': 'ទំនិញបន្ថែម​បន្ទប់',
  'menu.property-contact': 'ទំនាក់ទំនង​អចលនទ្រព្យ',
  'menu.about-rooms': 'បន្ទប់',
  'menu.special-emergencies': 'ករណីបន្ទាន់',
  'menu.show-filter': 'បង្ហាញតម្រង់',
  'menu.new': 'ថ្មី',
  'menu.channel': 'ប៉ុស្ដិ៍/ឆ្នេរ​ឆាត',
  'menu.application': 'កម្មវិធី',

  'dashboards.send': 'ផ្ញើ',
  'dashboards.hello': 'សួស្តី',
  'dashboards.notificationsAllowed': 'បានអនុញ្ញាតជូនដំណឹង',
  'dashboards.allowNotifications': 'អនុញ្ញាតការជូនដំណឹង',
  'dashboards.views': 'ចំនួនទស្សនា',
  'dashboards.bookingURL': 'URL កក់',
  'dashboards.searchTags': 'ស្លាកស្វែងរក',
  'dashboards.searchCategoryTags': 'ស្លាកប្រភេទស្វែងរក',
  'dashboards.bedroom': 'បន្ទប់គេង',
  'dashboards.addBedroom': 'បន្ថែមបន្ទប់គេង',
  'dashboards.frequency': 'ហេតុភាព',
  'dashboards.includeSubpages': 'រួមបញ្ចូលទំព័ររង',
  'dashboards.enableFaqs': 'អនុញ្ញាតសំណួរញឹកញាប់',
  'dashboards.faqsDescription': 'ការអនុញ្ញាតសំណួរញឹកញាប់ ឲ្យ​អ្នកបញ្ចូលសំណួរ ខណៈដែលប្រព័ន្ធ​ទាញយកចម្លើយពីមាតិកាទំព័របណ្តាញ ដើម្បីបង្កើតសំណួរញឹកញាប់​សព្វថ្ងៃ។',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'លុបឯកសារ',
  'dashboards.confirmDelete': 'តើ​អ្នកប្រាកដជាចង់លុបไหม?',
  'dashboards.addItem': 'បន្ថែមធាតុ',
  'dashboards.addFirstWebPage': 'បន្ថែមទំព័របណ្តាញដំបូងរបស់អ្នក',

  'dashboards.popular-compendium': 'មួយចំណុចរុករកពេញនិយម',
  'dashboards.wordcloudofcompendium': 'ពពកពាក្យនៃមីនុយ Compendium',
  'dashboards.wordcloudonthings': 'ពពកពាក្យអំពីអ្វីដែលអ្នកទស្សនាបណ្តាញសួរនិងមីនុយ',
  'dashboards.common-asked': 'សំណួរញឹកញាប់សួរដោយសាធារណៈ',

  'dashboards.website-visitor-asking': 'អ្វីដែលអ្នកទស្សនាបណ្តាញកំពុងសួរ',
  'dashboards.visit-country': 'ទស្សនាជាតិម្ដង',
  'dashboards.visit-traffic': 'ចរាចរបណ្តាញតាមប្រទេស',
  'dashboards.rooms-product': 'បន្ទប់ & ផលិតផល',
  'dashboards.popular-room-product': 'បន្ទប់និងផលិតផលពេញនិយម',

  'dashboards.messenger-stats': 'ព័ត៌មានខាងម៉ឺសេនជ័រ',
  'dashboards.messenger-stats-topic-view': 'ស្ថិតិចំនួនទស្សនាមីនុយ',
  'dashboards.messenger-stats-visits': 'ចំនួនទស្សនាមីនុយ',
  'dashboards.opening-menu-items': 'ចំនួនអ្នកទស្សនាបើកមីនុយ',

  'dashboards.number-totalavatarclick': 'ចំនួនចុចអាវ៉ាតារ​សរុប',

  'dashboards.clicks': 'ចុច',
  'dashboards.leads': 'គ្រោងតាម',
  'dashboards.hours': 'ម៉ោង',
  'dashboards.minutes': 'នាទី',
  'dashboards.connect': 'ភ្ជាប់',
  'dashboards.ai-chatbot': 'ឆាតបូត AI',
  'dashboards.compendium': 'Compendium',
  'dashboards.compendium-digital-usage': 'ការប្រើប្រាស់ឌីជីថល Compendium',
  'dashboards.compendium-unique-visits': 'ការស្កេន/ចុច QR Code',
  'dashboards.compendium-opening-menu-items': 'ចំនួនមីនុយដែលត្រូវបានមើល',
  'dashboards.compendium-total-digital-clicks': 'ចុច មីនុយសរុប',
  'dashboards.compendium-total-qr-code': 'ចំនួន QR Code ស្កេន/ចុចសរុប',
  'dashboards.compendium-avg-menu-items': 'មធ្យមមីនុយមើល បន្ទាប់ពី ស្កេន',

  'property.delete': 'លុប',
  'menu.userroles': 'អ្នកប្រើ & តួនាទី',
  'menu.members': 'សមាជិក',
  'menu.guest-pass': 'ប័ណ្ណ​អញ្ជើញភ្ញៀវ',
  'menu.ratebookings': 'អត្រា & ការកក់',
  'dashboards.engagement-time': 'រយៈពេល ការចូលរួម នៃការជជែក',
  'dashboards.conversations-minutes': 'ចំនួននាទីនិងយប់ (ដល់ ម៉ោង 7 ល្ងាច ដល់ 7 ព្រឹក) នៃការជជែក',
  'dashboards.visitor-questions': 'សំណួរអ្នកទស្សនា',
  'dashboards.recent-queries': 'សំណួរថ្មីៗ',
  'dashboards.visitor-saying': 'អ្វីដែលអ្នកទស្សនាកំពុងនិយាយពី',
  'dashboards.contacts-prechatform-leavemessage': 'ទំនាក់ទំនងពីសំណុំសំណួរពេលចូលជាមុន & សារម្ដង',
  'menu.dashboards': 'ចំណេះដឹង',
  'menu.ari': 'ភាពអាចប្រើបាន & អត្រា',
  'menu.conversations': 'ការជជែក',
  'menu.conversations.unified-inbox': 'ប្រអប់​ទទួលមួយ',
  'menu.conversations.active': 'ជំនួយភ្នាក់ងារ',
  'menu.conversations.archives': 'សារសន្សំ',
  'menu.conversations.missed-responses': 'ចម្លើយអវរ',
  'menu.conversations.ticket': 'សំបុត្រ',
  'menu.conversations.reply-templates': 'ទម្រង់ចម្លើយ',
  'menu.bookings': 'ការកក់ & អនុវត្ត',
  'menu.tickets': 'ការគោត & សំបុត្រ',
  'menu.propinfo': 'មូលដ្ឋានចំណេះដឹង',
  'menu.rate-promos': 'អត្រា & ការផ្សព្វផ្សាយ',
  'menu.finance': 'ហិរញ្ញវត្ថុ',
  'menu.integration': 'ភ្ជាប់',
  'menu.admin': 'រដ្ឋបាល & សុវត្ថិភាព',
  'menu.favourites': 'ចំណូលចិត្ត',
  'menu.recommender': 'ហ្វ្លូវជជែក',
  'menu.assistant-setup': 'ការតំឡើងជំនួយការ',
  'menu.admin-insights': 'ព័ត៌មានរដ្ឋបាល',
  'menu.super-admin': 'ស៊ុប អេដមីន',
  'menu.groups': 'ក្រុម',
  'menu.properties': 'អចលនទ្រព្យ',
  'menu.service-provider': 'អ្នកផ្គត់ផ្គង់សេវា',
  'menu.spaces': 'លំនៅ',
  'menu.content-manager': 'អ្នកគ្រប់គ្រងមាតិកា',
  'menu.events-calendar': 'ប្រតិទិនកម្មវិធី',
  'menu.appearance-settings': 'របៀបរូបរាង & ការកំណត់',
  'menu.help': 'ជំនួយ',
  'menu.availability': 'ភាពអាចប្រើបាន',
  'menu.myAccounts': 'គណនីរបស់ខ្ញុំ',
  'menu.guest-messaging': 'សារអតិថិជន',
  'dashboards.tickets-by-category': 'សំបុត្រតាមប្រភេទ',
  'dashboards.download': 'ទាញយក',
  'dashboards.space-booking': 'កក់លំនៅ',
  'dashboards.gift-voucher': 'Voucher ខួបកំណើត',
  'dashboards.chatbots': 'Chatbots',
  'dashboards.form': 'ពី',
  'dashboards.to': 'ដល់',
  'dashboards.active-groups': 'ក្រុមដំនើរការ',
  'dashboards.active-properties': 'អចលនទ្រព្យដំនើរការ',
  'dashboards.live-properties': 'អចលនទ្រព្យទាំងមាន',
  'dashboards.properties-going': 'អចលនទ្រព្យកំពុងទៅផ្លូវសកម្មតាមពេល',
  'dashboards.start-date': 'ថ្ងៃចាប់ផ្តើម',
  'dashboards.end-date': 'ថ្ងៃបញ្ចប់',
  'dashboards.all-properties-with': 'អចលនទ្រព្យទាំងអស់ដែលមានស្ថានភាពចូលមានរួម',
  'dashboards.aibot-by-country': 'អតិថិជន Chatbot AI តាមប្រទេស',
  'dashboards.list-live-clients': 'បញ្ជីអតិថិជនផ្ទាល់ខ្លួនប្រើ Chatbot AI',
  'dashboards.subscribe-to-reports': 'ជាវរាយការណ៍',
  'dashboards.website-visits': 'ចូលទស្សនាបណ្តាញ',
  'dashboards.unique-visitors': 'អ្នកទស្សនាពិសេស',
  'dashboards.last-week': 'សប្ដាហ៍មុន',
  'dashboards.this-week': 'សប្ដាហ៍នេះ',
  'dashboards.this-month': 'ខែនេះ',
  'dashboards.previous-month': 'ខែមុន',
  'dashboards.yeartodate': 'ឆ្នាំមកម៉ោងនេះ',
  'dashboards.lastyear': 'ឆ្នាំមុន',
  'dashboards.last-7-days': '​៧ថ្ងៃចុងក្រោយ',
  'dashboards.last-30-days': '​៣០ថ្ងៃចុងក្រោយ',
  'dashboards.last-60-days': '​៦០ថ្ងៃចុងក្រោយ',
  'dashboards.last-90-days': '​៩០ថ្ងៃចុងក្រោយ',
  'dashboards.conversion-rates': 'អត្រាបម្លែង',
  'dashboards.digital-assistant-engagement': 'ការចូលរួមជាមួយជំនួយការឌីជីថល',
  'dashboards.total-overnight-conversations': 'ចំនួនសន្ទនាមួយយប់ (7 ព្រឹក->7 ល្ងាច)',
  'dashboards.percentage-accuracy': 'ភាគរយភាពត្រឹមត្រូវ',
  'dashboards.percentage-conversion': 'ភាគរយចូលទៅកក់',
  'dashboards.percentage-avatarclick': 'ភាគរយចុចអាវ៉ាតារ',
  'dashboards.percentage-negativefeedback': 'ភាគរយមតិកំហុសចំពោះចុចអាវ៉ាតារ',
  'dashboards.percentage-amenties': 'សំណួរឧបករណ៍បន្ថែម',
  'dashboards.percentage-booking': 'សំណួរកក់',
  'dashboards.percentage-webchats': 'សន្ទនាផ្ទាល់តាមបណ្តាញ',
  'dashboards.percentage-facebookchat': 'សន្ទនាតាម Facebook',
  // 'dashboards.number-webchattime': 'Total Web Chat Time',
  'dashboards.number-webchattime': 'រយៈពេលសន្ទនាតាមបណ្តាញ',
  'dashboards.number-totalconversation': 'ចំនួនសន្ទនាសរុប',
  'dashboards.number-averagetimeconversation': 'ពេលមធ្យមក្នុងសន្ទនាមួយ',
  'dashboards.number-websiteconversation': 'សន្ទនាតាមបណ្តាញ',
  'dashboards.number-facebookconversation': 'សន្ទនាតាម Facebook',
  'dashboards.number-estimatedtimesaving': 'ការសន្មត់ថេលទុកកំណត់ពេល',
  'dashboards.number-googlemapsconversation': 'សន្ទនាតាម Google Maps',
  'dashboards.number-whatsappconversation': 'សន្ទតាម WhatsApp',
  'dashboards.number-instagramconversation': 'សន្ទនាតាម Instagram',
  'dashboards.number-agentconversation': 'សន្ទនាភ្នាក់ងារ',
  'dashboards.number-amenityqueries': 'សំណួរឧបករណ៍បន្ថែម',
  'dashboards.number-bookingenquiries': 'សំណួរកក់',
  'dashboards.number-groupbookingenquiries': 'សំណួរកក់ក្រុម',
  'dashboards.number-eventenquiries': 'សំណួរកម្មវិធី',
  'dashboards.number-longstayenquiries': 'សំណួរជួលរយៈពេលវែង',
  'dashboards.number-totaltickets': 'សំបុត្រសរុប',
  'dashboards.number-returncustomer': 'អតិថិជនត្រឡប់មកវិញ',
  'dashboards.number-redirects': 'បង្វិលវិញរបស់បណ្តាញ',
  'dashboards.number-bookingengineleads': 'នាំមុខពីម៉ាស៊ីនកក់',
  'dashboards.number-roomnightsreferred': 'យប់បន្ទប់ណាដែលបានយោង',
  'dashboards.number-revenuereferred': 'ប្រាក់ចំណូលដែលបានយោង',
  'menu.bookingsmenu': 'ការកក់',
  'menu.guests': 'ព័ត៌មានភ្ញៀវ',
  'menu.whatsnew': 'អ្វីថ្មី',

  'menu.formbuilder': 'អ្នកសាងសង់ទម្រង់',
  'forms.forms-title': 'ទម្រង់',
  'dashboards.trainAI': 'បណ្ដុះបណ្ដាល AI ដោយឯកសារ',
  'dashboards.uploadDocuments': 'ផ្គាប់ឯកសារដើម្បីជួយ AI រៀនអំពីអាជីវកម្មរបស់អ្នក និងជួយអតិថិជនដូចដែលអ្នកធ្វើ។ អ្នកអាចបន្ថែមឯកសារ .doc, .pdf, ឬ .txt។',
  'dashboards.welcomeMessage': 'សារស្វាគមន៍',
  'dashboards.personalizeGreeting': 'ផ្ទាល់ខ្លួនរបៀបស្វាគមន៍អតិថិជនឲ្យសមនឹងម៉ាស់សែន, ស្ទីល, និងអធិប្បាយភាព, ប្រាកដថាពួកគេទទួលបានការស្វាគមន៍ឱ្យកក់។ ប្ដូរជាសារស្វាគមន៍ឲ្យសមនឹងម៉ាស់សែនរបស់អ្នក។',
  'dashboards.addRoomDetails': 'បន្ថែមព័ត៌មានអំពីបន្ទប់រាល់មួយឲ្យភ្ញៀវអាចស្វែងរកអ្វីដែលពួកគេស្នាក់បានយ៉ាងឆាប់រហ័ស និងធ្វើឲ្យដំណើរការកក់កាន់តែងាយស្រួល។',
  'dashboards.trainAIFAQs': 'បណ្ដុះបណ្ដាល AIដោយសំណួរញឹកញាប់',
  'dashboards.manualQuestions': 'សំណួរមួយចំនួនមិនអាចបានចម្លើយពីឯកសារឬអាចរកបានពីគេហទំព័រ។ នៅទីនេះ អ្នកអាចបន្ថែមសំណួរផ្ទាល់ខ្លួន ដើម្បីប្រាកដថាអតិថិជនទាំងអស់មានព័ត៌មានពួកគេចង់ឲ្យ។',
  'dashboards.publishAI': 'ផ្សព្វផ្សាយ AI ដើម្បីបង្ហាញព័ត៌មានថ្មីបំផុត',
  'dashboards.retrainAfterChanges': 'ពេលដែលអ្នកធ្វើការផ្លាស់ប្ដូរនៅមូលដ្ឋានចំណេះដឹង ឬទម្រង់ សូមប្រាកដថាបង្កើតឡើងវិញ ជំនួយការជំនួយការជំនួយនេះផ្អែកលើព័ត៌មានទាន់សម័យ។',
  'dashboards.enhanceKnowledge': 'បង្កើនចំណេះដឹង AIដោយតាមដានសំណួរដែលមិនទទួលភ្លើយ',
  'dashboards.reviewUnanswered': 'ពេលណាដែល AI មិនអាចចម្លើយសំណួរឬផ្តល់បានតែព័ត៌មានកាត់បន្ថយ អ្នកនឹងឃើញសំណួរទាំងនោះក្នុងនេះ។ ពិនិត្យពួកវាឲ្យដឹងចន្លោះ នៅក្នុងមូលដ្ឋានចំណេះដឹងរបស់អ្នក ឬសំណួរពិសេសរបស់ភ្ញៀវ។',
  'dashboards.manageMedia': 'គ្រប់គ្រងសារព័ត៌មាន',
  'dashboards.mediaGallery': 'ពេលណាអ្នកផ្តល់រូបភាពដូចជា​បន្ទប់, សម្ភារៈបន្ថែម, ឬ​អាវ៉ាតារ​របស់អ្នក ពួកវានឹងបង្ហាញនៅក្នុងបណ្ណាល័យនេះ បង្កើតកន្លែងមួយដាក់គ្រប់រូបភាព និងប្រាកដថាភ្ញៀវរបស់អ្នកឃើញអ្វីដែលធ្វើឱ្យអាជីវកម្មរបស់អ្នកមានភាពដាច់ដោយឡែក។',
  'dashboards.createForms': 'បង្កើតទម្រង់យ៉ាងស្រួល និងទទួលបានសេចក្ដីជូនដំណឹងនៅពេលដែលអ្នកបញ្ជូនសំណុំ។',
  'dashboards.manageForms': 'បង្កើត និងគ្រប់គ្រងទម្រង់ ដើម្បីប្រមូលព័ត៌មាន​អតិថិជន បង្កើតការជូនដំណឹង និងផ្លាស់ប្ដូរពួកវាសម្រាប់ភាសាផ្សេងៗ។',
  'dashboards.personalizeResponse': 'ផ្ទាល់ខ្លួនរបៀបឆ្លើយតប និងដំណើរឆាត',
  'dashboards.controlConversation': 'មុខងារលំដាប់ខ្ពស់នេះផ្តល់ឱ្យអ្នកសមត្ថភាពក្នុងការទទួលសχήយក្នុងរបៀបដែលសន្ទនាទៅរៀងជាមួយអតិថិជនរបស់អ្នកតាមបណ្តាញផ្សេងៗ។',

  'menu.virtualfrontdesk': 'តុទទួលមុខងារឌីជីថល',
  'menu.guestservice': 'សេវាកម្មភ្ញៀវ',
  'virtual-front.common-questions': 'សំណួរញឹកញាប់',
  'virtual-front.add-on-upsells': 'ការបន្ថែម & លក់បន្ថែម',
  'virtual-front.service-order': 'ការកម្មង់សេវា',
  'virtual-front.guest-service-add-on-upsells': 'ឯកសារយោងឌីជីថល',
  'virtual-front.outbound': 'ចេញក្រៅ',
  'virtual-messenger': 'មីនុយវិលជ័របណ្ដាញ',

  'missed-response.missed-response-title': 'ចំណងជើងចម្លើយដែលខកខាន',
  // unified-inbox
  'content.allconversation': 'ការជជែកទាំងអស់',
  'content.active': 'សកម្ម',
  'content.tickets': 'សំបុត្រ',
  'content.filter': 'តម្រង់',
  'content.createtickets': 'បង្កើតសំបុត្រ',
  'content.conversation': 'ការជជែក',
  'content.knowledgesearch': 'ស្វែងរកចំណេះដឹង',
  'content.reply': 'ឆ្លើយតប',
  'content.visitorinfo': 'ព័ត៌មានភ្ញៀវ',
  'content.callinfo': 'ព័ត៌មានការហៅ',
  'content.allinsights': 'ចំណេះដឹងទាំងអស់',
  'content.availabilityrates': 'ភាពអាចប្រើបាន & អត្រា',
  'content.callback': 'ហៅត្រលប់',
  'content.close': 'បិទ',
  'content.sms': 'សារ SMS',
  'content.timestamp': 'ម៉ោង​ដាក់សញ្ញា',
  'content.topics': 'ប្រធានបទ',
  'content.callingparty': 'អ្នកហៅ',
  'content.accountdomain': 'ដែនប្រើប្រាស់គណនី',
  'content.calledparty': 'អ្នកដែលត្រូវហៅ',
  'content.recording': 'កំណត់ត្រា',
  'content.phonesystemoriginationcallid': 'លេខភ្ជាប់ការហៅចេញប្រព័ន្ធទូរស័ព្ទ',
  'content.phonesystemterminationcallid': 'លេខភ្ជាប់ការទទួលការហៅប្រព័ន្ធទូរស័ព្ទ',
  'content.uniqueconversationid': 'លេខសន្ទនាផ្ទាល់',
  'content.regenerateinsights': 'បង្កើតឡើងវិញចំណេះដឹង',
  'content.customersentiment': 'អារម្មណ៍អតិថិជន',
  'content.neutral': 'អៀងរវល់មិនទាំងអស់ទេ',
  'content.conversationinsights': 'ចំណេះដឹងពីសន្ទនា',
  'content.customeridverification': 'ការផ្ទៀងផ្ទាត់អត្តសញ្ញាណអតិថិជន',
  'content.serviceactivationdate': 'ថ្ងៃចាប់ផ្តើមសេវា',
  'content.followups': 'ការតាមដាន',
  'content.actionneeded': 'ការប្រារព្ធដែលត្រូវការម្ដង',
  'content.uniqueConversationId': 'លេខសន្ទនាផ្លាស់ប្ដូរពិសេស',
  'content.uniqueChatId': 'លេខជជែកផ្ទាល់',
  'content.recording&transcript': 'កំណត់ត្រា & បត្សារ',
  'content.chatinsights': 'ចំណេះដឹងពីការជជែក',
  'content.visitedpages': 'ទំព័រដែលបានទស្សនា',
  'content.deviceinfo': 'ព័ត៌មានឧបករណ៍',
  'content.chatstartedonthispage': 'ជជែកចាប់ផ្តើមលើទំព័រនេះ',
  'content.prechatinfo': 'ព័ត៌មានមុនជជែក',
  'content.notes': 'កំណត់សម្គាល់',
  'content.reassign': 'ផ្ទេរទំនាក់ទំនង',
  'content.open': 'បើក',
  "content.dismiss": "បិទ",
  "content.add_placeholder": "បន្ថែមតម្លៃកន្លែងជំនួស",
  "content.mobile_number": "លេខទូរស័ព្ទ",
  "content.please_select": "សូមជ្រើសរើស",
  'content.sendwhatsapp': 'ផ្ញើសារតាម WhatsApp',

  /* Missed-response */
  'feedback.missed-question': 'សំណួរដែលខកខាន',
  'feedback.conversation-summary': 'សង្ខេបសន្ទនា',
  'feedback.dates-in-spanish': 'ថ្ងៃត្រូវប្រើភាសាស្ប៉ាញ',
  'feedback.resolve': 'ដោះស្រាយ',
  'feedback.ignore': 'មិនយកចិត្តទុក​ដាក់',

  // integration
  'integration.select_properties': 'ជ្រើសអចលនទ្រព្យ',
  'integration.select_properties_enabled': 'ជ្រើសអចលនទ្រព្យដែលបានបើកតាមរយៈការភ្ជាប់នេះ',
  'integration.services_addons': 'ជ្រើសសេវាកម្ម & បន្ថែមផែនការ',
  'integration.services_visible': 'ជ្រើសអ្វីសេវាកម្ម & បន្ថែមដែលនឹងបង្ហាញនៅលើទំព័រនេះ',
  'integration.appearance': 'មុខរបរ',
  'integration.appearance_customize': 'ជ្រើសឈ្មោះជំនួយការឌីជីថលរបស់អ្នក, អាវ៉ាតារ និងកំណត់ពណ៌របស់អ្នក',
  'integration.booking_calendar': 'បញ្ញតកាលវិភាគកក់',
  'integration.booking_calendar_style': 'ជ្រើសរចនាបថសម្រាប់បញ្ញាតកាលវិភាគកក់រូបភាព',
  'integration.nudges': 'ស្នើសុំ',
  'integration.nudges_setup': 'បង្កើតសារម៉ាក់ទាក់ទាញដើម្បីទាក់ទងជាមួយអ្នកទស្សនាបណ្តាញ',
  'integration.position': 'ទីតាំង',
  'integration.position_control': 'គ្រប់គ្រងទីតាំងនៃវិលជ័រឆាតលើគេហទំព័រ',
  'integration.custom_fonts': 'ពុម្ពអតិថិជន',
  'integration.custom_fonts_upload': 'ផ្ទុកពុម្ពអតិថិជនណាមួយដែលអ្នកចង់ប្រើសម្រាប់ទំព័រ',
  'integration.custom_css': 'CSS អតិថិជន',
  'integration.custom_css_usage': 'ប្រើ CSS ដើម្បីប្ដូរមុខរបរវិលជ័រលើគេហទំព័រ',
  'integration.location': 'ទីតាំង',
  'integration.location_embed': 'បន្ថែម URL ទីតាំង embed',
  'integration.external_links': 'តំណភ្ជាប់ខាងក្រៅ',
  'integration.external_links_add': 'បន្ថែមតំណភ្ជាប់របស់អ្នក',
  'integration.language': 'ភាសា',
  'integration.widget_languages': 'ជ្រើសភាសាសម្រាប់វិលជ័រឆាត',
  'integration.chatbot_contact': 'ជំនួយការ Chatbot',
  'integration.chatbot_enable': 'បើកប្រើជំនួយការឌីជីថលរបស់អ្នក',
  'integration.chatbot_security': 'រក្សាសុវត្ថិភាព Messenger របស់អ្នក',
  'integration.chatbot_trusted_pages': 'បញ្ជីទំព័រដែលទុកចិត្តសម្រាប់បង្ហាញ Chatbot',
  'integration.chatbot_publish': 'ផ្សព្វផ្សាយជំនួយការឌីជីថលរបស់អ្នក',
  'integration.chatbot_install': 'ចម្លងខ្លឹមសារ​កូដដើម្បីដំឡើងជំនួយការឌីជីថលរបស់អ្នក',


  'guest-messaging.settings': 'ការកំណត់អតិថិជន',
  'guest-messaging.outreach-setup': 'ការរៀបចំការទំនាក់ទំនង',
  'guest-messaging.reservations': 'ការកក់',
  'guest-messaging.insights_logs': 'ការយល់ដឹង និងកំណត់ត្រា',
  'guest-messaging.reservation-source': 'ប្រភពទិន្នន័យការកក់',
  'guest-messaging.communication-channels': 'ឆានែលទំនាក់ទំនង',
  'guest-messaging.templates': 'គំរូសារទំនាក់ទំនង',
  'guest-messaging.link': 'ការបង្កើតតំណ',
  'guest-messaging.business-profile': 'ប្រវត្តិសាស្ត្រអាជីវកម្ម',



};
export default kmMessages;
